<template>
  <div class="box">
    <div class="columns">
      <div class="column is-two-thirds">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Email</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder=""
                  v-model="filterParams.email"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Username</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder=""
                  v-model="filterParams.username"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">First Name</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder=""
                  v-model="filterParams.firstName"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Last Name</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder=""
                  v-model="filterParams.lastName"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="['is-divider-vertical', $style.divider]"></div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <b-field label="User Status">
              <b-dropdown
                v-model="filterParams.selectedStatus"
                aria-role="list"
                class="simple-dropdown"
              >
                <button
                  class="button is-primary role-select-button"
                  slot="trigger"
                >
                  <span class="text-input">
                    {{
                      filterParams.selectedStatus === userStatusOptions.all
                        ? 'All Status'
                        : filterParams.selectedStatus ===
                          userStatusOptions.active
                        ? 'Active'
                        : 'Expired'
                    }}
                  </span>
                  <b-icon
                    type="is-black"
                    icon="menu-down"
                    size="is-small"
                  ></b-icon>
                </button>

                <b-dropdown-item
                  :value="value"
                  v-for="value in userStatusOptions"
                  :key="value"
                  aria-role="listitem"
                  class="simple-dropdown-item"
                >
                  {{
                    value === userStatusOptions.all
                      ? 'All Status'
                      : value === userStatusOptions.active
                      ? 'Active'
                      : 'Expired'
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left" />
      <div class="level-right">
        <a @click="$emit('reset')" :class="[$style.clearFilter, `level-item`]">
          Clear Filter
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilteredUserPayload } from '@/store/modules/users/types/users.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';

@Component({
  components: {},
})
export default class UserFilter extends Vue {
  @Prop(Object) public filterParams!: FilteredUserPayload;
  public userStatusOptions = {
    all: '',
    active: 'active',
    expired: 'expired',
  };

  @Watch('filterParams', { deep: true })
  public onChange() {
    this.$emit('input', this.filterParams);
  }
}
</script>

<style lang="scss" module>
.clearFilter {
  color: #21b5ea;
  font-size: 14px;
  font-weight: bold;
}
.divider {
  height: 180px;
}
</style>
